import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "../view/user/login/Login";
import Register from "../view/demo/Register/Register";
import Account from "../view/user/account";
import Audio from "../view/user/audio";
import AudioTable from "../view/user/audio/AudioTable";
import Setting from "../view/user/setting";
import DashBoard from "../view/user/dashboard";
import FileUpload from "../view/demo/audio/FileUpload";
import SingleAudioDetails from "../view/demo/audio/SingleAudioDetails";
import TranscriptDetails from "../view/demo/audio/TranscriptDetails";
// import DemoAudioAnalytics from "../view/user/audioAnalytics";
import SuperAdminDashboard from "../view/superAdmin/dashboard";
import SuperAdminUserManagement from "../view/superAdmin/userManagement";
import SuperAdminProcessManagement from '../view/superAdmin/processManagement'
import SuperAdminClientManagement from '../view/superAdmin/clientManagement'
import CompanyAccess from "../view/superAdmin/companyAccess";
import Billing from "../view/superAdmin/billingAnalytics";
import AudioIntelligence from "../view/user/audioIntelligence";
import Layout from "../layout";
import AgentCreateForm from "../view/superAdmin/agentCreate/AgentCreateForm";
import { ProtectedRoute, RoleBasedRedirect } from "../routes/ProtectedRoute";
import AgentDashBoard from "../view/agent/dashboard";
import MyKpis from "../view/agent/kpis";
import MyCalls from "../view/agent/myCalls";
import DailyTask from "../view/agent/dailyTask";
import LeaderBoardHome from "../view/agent/leaderboard";
import Subscription from "../view/Subscription";
import LeaderBoard from "../view/user/LeaderBoard";
import Settings from "../view/settings";
import Billings from "../view/user/Billing";
import AgentProfile from "../view/user/agentProfile";
import UserManagement from "../../src/view/user/userManagement/index"
import AgentList from "../../src/view/user/AgentList";
import NotFound from "../../src/components/PageNotFound"
import Dashboard2 from "../view/user/dashboard2";
import Training from "../view/user/training";
import AccountManagement from "../view/user/AccountManagement";
import { Dashboard } from "@mui/icons-material";
import ChatbotUI from "../view/agent/chatbot";
import Invoices from "../view/superAdmin/billingAnalytics/invoice";
import QAParametersModal from "../components/commonQA";
import EntityConfigModal from "../components/commonEntities";
import RediarizationPrompt from "../components/commonRediarization";
import OverViewPrompt from "../components/commonOverviewPrompt";
import CustomerInsightPrompt from "../components/commonCustomerInsightPrompt";
import AgantInsightPrompt from "../components/commonAgentInsightPrompt";
import ConversionInsightPrompt from "../components/commonConversion";
import ApiTester from "../components/crm-integration";
import MPokketDashboard from "../view/user/mPokketDashboard";
import QaEditPage from "../view/user/qaEdit";
import VoiceCapture from "../view/user/voice-capture/VoiceCapture";


const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <RoleBasedRedirect />,
      },
      {
        path: "/user/dashboard",
        element: (
          <ProtectedRoute element={<Dashboard2 />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      // {
      //   path: "/user/mpokket-dashboard",
      //   element: (
      //     <ProtectedRoute element={<MPokketDashboard />} allowedRoles={["Manager", "Admin"]} />
      //   ),
      // },

      {
        path: "/user/dashboard2",
        element: (
          <ProtectedRoute element={<Dashboard />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      {
        path: "/user/audio",
        element: (
          <ProtectedRoute element={<Audio />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      {
        path: "/user/account",
        element: (
          <ProtectedRoute element={<Account />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      {
        path: "/user/setting",
        element: (
          <ProtectedRoute element={<Setting />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      {
        path: "/user/leaderboard",
        element: (
          <ProtectedRoute
            element={<LeaderBoard />}
            allowedRoles={["Manager", "Admin", "Curator"]}
          />
        ),
      },
      {
        path: "/user/audio-details",
        element: (
          <ProtectedRoute element={<AudioTable />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      {
        path: "/user/qa-edit/:id",
        element: (
          <ProtectedRoute
            element={<QaEditPage />}
            allowedRoles={["Manager", "Admin", "Curator"]}
          />
        ),
      },
      {
        path: "/user/audio-analytics/:id",
        element: (
          <ProtectedRoute
            element={<AudioIntelligence />}
            allowedRoles={["Manager", "Admin", "Agent", "Curator"]}
          />
        ),
      },
      {
        path: "/user/audio-intelligence",
        element: (
          <ProtectedRoute
            element={<AudioIntelligence />}
            allowedRoles={["Manager", "Admin", "Curator"]}
          />
        ),
      },
      {
        path: "/user/agent-profile/:id",
        element: (
          <ProtectedRoute element={<AgentProfile />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      {
        path: "/user/settings",
        element: (
          <ProtectedRoute element={<Settings />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      {
        path: "/user/billing",
        element: (
          <ProtectedRoute element={<Billings />} allowedRoles={["Manager", "Admin"]} />
        ),
      },
      {
        path: "/user/user-management",
        element: (
          <ProtectedRoute element={<UserManagement />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      {
        path: "/user/agent/list",
        element: (
          <ProtectedRoute element={<AgentList />} allowedRoles={["Manager", "Admin",]} />
        ),
      },

      {
        path: "/user/training",
        element: (
          <ProtectedRoute element={<Training />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      {
        path: "/user/account/manage",
        element: (
          <ProtectedRoute element={<AccountManagement />} allowedRoles={["Manager", "Admin", "Curator"]} />
        ),
      },
      {
        path: "/user/crm-integration",
        element: (
          <ProtectedRoute
            element={<ApiTester />}
            allowedRoles={["Manager", "Admin", "Curator"]}
          />
        ),
      },
      //// demo user
      // {
      //   path: "/demo/audio-analytics/:id",
      //   element: (
      //     <ProtectedRoute
      //       element={<DemoAudioAnalytics />}
      //       allowedRoles={["Guest"]}
      //     />
      //   ),
      // },
      {
        path: "/demo/audio/upload-file",
        element: (
          <ProtectedRoute element={<FileUpload />} allowedRoles={["Guest"]} />
        ),
      },
      {
        path: "/demo/audio/file-details",
        element: (
          <ProtectedRoute
            element={<SingleAudioDetails />}
            allowedRoles={["Guest"]}
          />
        ),
      },
      {
        path: "/demo/audio/transcript/:id",
        element: (
          <ProtectedRoute
            element={<TranscriptDetails />}
            allowedRoles={["Guest"]}
          />
        ),
      },
      /// super-admin routes
      {
        path: "/super-admin/dashboard",
        element: (
          <ProtectedRoute
            element={<SuperAdminDashboard />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "/super-admin/process-management",
        element: (
          <ProtectedRoute
            element={<SuperAdminProcessManagement />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "/super-admin/client-management",
        element: (
          <ProtectedRoute
            element={<SuperAdminClientManagement />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "/super-admin/agent-create",
        element: (
          <ProtectedRoute element={<AgentCreateForm />} allowedRoles={["SuperAdmin"]} />
        ),
      },
      {
        path: "/super-admin/qa-parameter-prompt/:companyId/:processType",
        element: (
          <ProtectedRoute
            element={<QAParametersModal />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "super-admin/entities-prompt/:companyId/:processType",
        element: (
          <ProtectedRoute
            element={<EntityConfigModal />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "super-admin/rediarization-prompt/:companyId/:processType",
        element: (
          <ProtectedRoute
            element={<RediarizationPrompt />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "super-admin/overview-prompt/:companyId/:processType",
        element: (
          <ProtectedRoute
            element={<OverViewPrompt />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "super-admin/customer-insight-prompt/:companyId/:processType",
        element: (
          <ProtectedRoute
            element={<CustomerInsightPrompt />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "super-admin/agent-insight-prompt/:companyId/:processType",
        element: (
          <ProtectedRoute
            element={<AgantInsightPrompt />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "super-admin/conversion-insight-prompt/:companyId/:processType",
        element: (
          <ProtectedRoute
            element={<ConversionInsightPrompt />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "/super-admin/user-management",
        element: (
          <ProtectedRoute
            element={<SuperAdminUserManagement />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "/super-admin/company-access",
        element: (
          <ProtectedRoute
            element={<CompanyAccess />}
            allowedRoles={["SuperAdmin"]}
          />
        ),
      },
      {
        path: "/super-admin/billing",
        element: (
          <ProtectedRoute element={<Billing />} allowedRoles={["SuperAdmin"]} />
        ),
      },
      {
        path: "/super-admin/billing/invoice",
        element: (
          <ProtectedRoute element={<Invoices />} allowedRoles={["SuperAdmin"]} />
        ),
      },
      /// agent-admin routes
      {
        path: "/agent/dashboard",
        element: (
          <ProtectedRoute
            element={<AgentDashBoard />}
            allowedRoles={["Agent"]}
          />
        ),
      },
      {
        path: "/agent/chatbot",
        element: (
          <ProtectedRoute
            element={<ChatbotUI />}
            allowedRoles={["Agent"]}
          />
        ),
      },
      {
        path: "/agent/my-calls",
        element: (
          <ProtectedRoute element={<MyCalls />} allowedRoles={["Agent"]} />
        ),
      },
      {
        path: "/agent/my-kpis",
        element: (
          <ProtectedRoute element={<MyKpis />} allowedRoles={["Agent"]} />
        ),
      },
      {
        path: "/agent/daily-tasks",
        element: (
          <ProtectedRoute element={<DailyTask />} allowedRoles={["Agent"]} />
        ),
      },
      {
        path: "/agent/leaderboard",
        element: (
          <ProtectedRoute
            element={<LeaderBoardHome />}
            allowedRoles={["Agent"]}
          />
        ),
      },
      {
        path: "/agent/settings",
        element: (
          <ProtectedRoute element={<Settings />} allowedRoles={["Agent"]} />
        ),
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/sign-in",
    element: <Login />,
  },
  {
    path: "/sign-up",
    element: <Register />,
  },
  {
    path: "/subscription",
    element: <Subscription />,
  },
  {
    path: "/voice-capture",
    element: <VoiceCapture />,
  },
  {
    path: "*",
    element: <NotFound />
  }
]);

export default router;
